export interface Article {
  id: string;
  title: string;
  slug: string;
  category: string;
  categorySlug: string;
  excerpt: string;
  content: string;
  coverImage: string;
  date: string;
  author: string;
  tags: string[];
  viewCount: number;
}

export const articles: Article[] = [
  {
    id: "a1",
    title: "佐佐木希最新秋季写真集《Autumn Whisper》即将发售",
    slug: "autumn-whisper-photo-book-2026",
    category: "写真精选",
    categorySlug: "photo",
    excerpt: "佐佐木希时隔三年再度推出个人写真集《Autumn Whisper》，全篇在京都取景拍摄，融合古都秋色与女神优雅气质，收录超过150张精选照片。",
    content: `<p>日本顶级女艺人佐佐木希宣布将于2026年9月推出全新个人写真集《Autumn Whisper》（秋日私语）。这是她继《Nozomi》之后时隔三年再度推出的个人写真作品。</p>
    <p>据悉，此次写真集全篇在京都取景拍摄，以古都的秋日美景为背景，展现了佐佐木希成熟优雅的一面。写真集由知名摄影师蜷川实花掌镜，融合了传统和风美学与现代时尚感。</p>
    <p>写真集将收录超过150张精选照片，涵盖和服造型、现代时装以及自然生活等多个主题。佐佐木希在接受采访时表示："京都是一个充满故事的地方，希望透过这次的作品，让大家看到不一样的我。"</p>
    <p>《Autumn Whisper》将于9月15日在日本全国书店发售，同时提供限量版特典，包含签名照片和拍摄幕后DVD。预售将于8月20日在各大在线平台开启。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Elegant%20Japanese%20female%20model%20in%20autumn%20kimono%20standing%20in%20Kyoto%20bamboo%20forest%20with%20golden%20maple%20leaves%2C%20soft%20natural%20lighting%2C%20dreamy%20atmosphere%2C%20editorial%20fashion%20photography%2C%20warm%20amber%20tones%2C%20minimalist%20composition&width=800&height=600&seq=article-a1-cover&orientation=landscape",
    date: "2026-08-10",
    author: "编辑部",
    tags: ["写真集", "Autumn Whisper", "京都", "蜷川实花"],
    viewCount: 12850,
  },
  {
    id: "a2",
    title: "佐佐木希出席东京国际电影节，一袭白色长裙惊艳红毯",
    slug: "tokyo-film-festival-2026-red-carpet",
    category: "最新动态",
    categorySlug: "news",
    excerpt: "佐佐木希优雅亮相第38届东京国际电影节红毯，身着一袭定制白色缎面长裙，搭配简约珠宝，展现一如既往的女神风采，成为全场焦点。",
    content: `<p>第38届东京国际电影节于昨日在六本木盛大开幕，佐佐木希作为特别嘉宾亮相红毯，瞬间成为全场焦点。</p>
    <p>她身着一袭定制的白色缎面长裙，来自日本设计师品牌TADASHI SHOJI的特别定制款。简约的剪裁搭配精致的褶皱细节，完美衬托出她优雅的气质。珠宝方面选择了日本品牌MIKIMOTO的珍珠系列，低调中透着高级感。</p>
    <p>在接受媒体采访时，佐佐木希分享了自己对日本电影发展的看法，并表示非常期待看到更多优秀的日本作品走向国际舞台。她还透露自己正在考虑出演一部国际合作的电影项目。</p>
    <p>红毯环节结束后，佐佐木希还参加了电影节的开幕影片《风之记忆》的首映礼，与导演及主创团队进行了深入交流。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Elegant%20Japanese%20woman%20in%20white%20silk%20evening%20gown%20on%20red%20carpet%20at%20film%20festival%2C%20pearl%20jewelry%2C%20camera%20flashes%20in%20background%2C%20glamorous%20celebrity%20event%20photography%2C%20warm%20golden%20spotlight%20lighting%2C%20sophisticated%20editorial%20style&width=800&height=600&seq=article-a2-cover&orientation=landscape",
    date: "2026-08-05",
    author: "编辑部",
    tags: ["东京国际电影节", "红毯", "时尚造型", "TADASHI SHOJI"],
    viewCount: 9850,
  },
  {
    id: "a3",
    title: "秋季日剧情报：佐佐木希确定出演TBS新剧《月光之约》",
    slug: "tbs-drama-moonlight-promise-2026",
    category: "影视作品",
    categorySlug: "drama",
    excerpt: "TBS电视台正式公布秋季档日剧《月光之约》主演阵容，佐佐木希将出演女主角，饰演一位在月光下邂逅命运的钢琴教师，新剧将于10月首播。",
    content: `<p>TBS电视台今日正式公布了2026年秋季档日剧《月光之约》（月光の約束）的完整主演阵容，佐佐木希确认出演女主角。</p>
    <p>《月光之约》讲述了一位钢琴教师在月光下的公园邂逅了一位神秘男子，两人因音乐结缘而展开的一段温暖而深刻的故事。佐佐木希将饰演女主角"月岛樱"，一位因手部受伤而暂别舞台的天才钢琴家。</p>
    <p>这是佐佐木希自《FIRST CLASS 2》之后时隔多年再度出演TBS电视台的电视剧。与她搭档的是实力派演员吉沢亮，两人将首次在荧幕上合作。</p>
    <p>制作人山本表示："佐佐木希身上那种温柔中带着坚韧的气质，与月岛樱这个角色完美契合。我们相信她会带给观众一个令人难忘的表演。"新剧将于10月12日起每周二晚10点播出。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20actress%20sitting%20at%20grand%20piano%20in%20moonlit%20room%20with%20large%20windows%2C%20elegant%20evening%20dress%2C%20romantic%20melancholic%20atmosphere%2C%20soft%20blue%20moonlight%2C%20cinematic%20lighting%2C%20editorial%20photography%2C%20minimalist%20composition&width=800&height=600&seq=article-a3-cover&orientation=landscape",
    date: "2026-07-28",
    author: "编辑部",
    tags: ["月光之约", "TBS", "秋季日剧", "吉沢亮"],
    viewCount: 15320,
  },
  {
    id: "a4",
    title: "佐佐木希×GU合作系列发布，演绎秋日通勤穿搭美学",
    slug: "gu-collaboration-2026-autumn",
    category: "时尚造型",
    categorySlug: "fashion",
    excerpt: "佐佐木希与日本人气品牌GU推出联名合作系列「Nozomi meets GU」，主打秋日通勤风格，以大地色系和柔软材质打造优雅日常穿搭。",
    content: `<p>日本人气时尚品牌GU正式发布了与佐佐木希的联名合作系列「Nozomi meets GU」，这是佐佐木希首次与快时尚品牌进行深度合作。</p>
    <p>该系列以"秋日通勤美学"为主题，主打大地色系和柔软亲肤的材质。系列涵盖了针织衫、阔腿裤、风衣外套、连衣裙等多个品类，价格区间在1990日元至4990日元之间，延续了GU一贯的高性价比定位。</p>
    <p>佐佐木希亲自参与了整个系列的设计过程，从面料选择到版型调整都给出了自己的建议。"我希望这个系列能让每位女性都能轻松穿出属于自己的风格，无论是上班还是约会，都能感到自信和舒适。"</p>
    <p>该系列将于9月1日起在GU全国门店及官网同步发售，同时还会推出限量版的佐佐木希亲笔签名明信片作为购买特典。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20fashion%20model%20wearing%20elegant%20autumn%20beige%20knitwear%20and%20wide%20leg%20trousers%20in%20modern%20minimalist%20studio%2C%20warm%20earth%20tone%20colors%2C%20soft%20natural%20window%20light%2C%20fashion%20editorial%20photography%2C%20clean%20composition&width=800&height=600&seq=article-a4-cover&orientation=landscape",
    date: "2026-07-20",
    author: "编辑部",
    tags: ["GU", "联名合作", "秋日穿搭", "快时尚"],
    viewCount: 11230,
  },
  {
    id: "a5",
    title: "从秋田到东京：佐佐木希出道18周年特别回顾",
    slug: "18th-anniversary-career-retrospective",
    category: "最新动态",
    categorySlug: "news",
    excerpt: "2026年是佐佐木希出道18周年，让我们一同回顾她从秋田县普通女孩成长为日本国民女神的传奇历程，见证18年来的精彩蜕变。",
    content: `<p>2026年，佐佐木希迎来了她出道18周年的重要里程碑。18年前，这位来自秋田县的普通女孩以模特身份踏入演艺圈，如今已成为日本最具代表性的女艺人之一。</p>
    <p>1988年出生于秋田县的佐佐木希，高中时期在当地的购物中心被星探发掘，随后以杂志《Pinky》的专属模特身份出道。凭借精致五官和独特气质，她迅速成为日本最受欢迎的杂志模特之一。</p>
    <p>2009年，佐佐木希凭借电影《天使之恋》正式进军影视圈，展现了不俗的演技实力。此后她陆续出演了《FIRST CLASS》、《东京机场管制保全局》、《世界奇妙物语》等多部热门剧集，戏路不断拓宽。</p>
    <p>除了模特和演员身份，佐佐木希在时尚领域也有着举足轻重的影响力。她多次被评为"日本女性最想拥有的面孔"，其穿搭风格被无数女性效仿。18年来，佐佐木希用她的努力和才华，完成了从秋田少女到国民女神的华丽蜕变。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20female%20celebrity%20elegant%20portrait%20in%20white%20studio%20with%20soft%20natural%20lighting%2C%20timeless%20beauty%2C%20minimalist%20neutral%20background%2C%20editorial%20fashion%20photography%2C%20warm%20soft%20tones%2C%20sophisticated%20elegance&width=800&height=600&seq=article-a5-cover&orientation=landscape",
    date: "2026-07-15",
    author: "编辑部",
    tags: ["出道18周年", "回顾", "秋田", "演艺生涯"],
    viewCount: 18640,
  },
  {
    id: "a6",
    title: "佐佐木希粉丝见面会「夏日之约」东京场圆满落幕",
    slug: "summer-fan-meeting-2026-tokyo",
    category: "粉丝应援",
    categorySlug: "fan",
    excerpt: "佐佐木希「夏日之约」粉丝见面会东京场于昨日在东京巨蛋城圆满举行，超过3000名粉丝到场参与，现场气氛温馨热烈。",
    content: `<p>佐佐木希「夏日之约」粉丝见面会东京场于昨日在东京巨蛋城圆满举行，吸引了来自日本全国乃至海外的超过3000名粉丝到场。</p>
    <p>见面会上，佐佐木希以一身淡蓝色碎花连衣裙亮相，清新自然的造型让现场粉丝惊喜不已。她不仅分享了自己近期的生活趣事和工作计划，还与粉丝们进行了亲密互动，包括问答环节、合影时间以及惊喜抽奖。</p>
    <p>最令人感动的是粉丝特别准备的应援环节——全场粉丝举起蓝色荧光棒，合唱佐佐木希主演日剧的主题曲，场面温馨感人。佐佐木希在台上感动落泪，表示"因为有大家的支持，我才能一直走到今天"。</p>
    <p>据悉，「夏日之约」系列见面会还将在名古屋和大阪举办，让更多粉丝有机会近距离接触心目中的女神。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20female%20celebrity%20on%20stage%20at%20fan%20meeting%20event%20with%20blue%20light%20sticks%20in%20audience%2C%20warm%20atmosphere%2C%20smiling%20and%20waving%2C%20concert%20hall%20with%20spotlights%2C%20emotional%20moment%2C%20event%20photography&width=800&height=600&seq=article-a6-cover&orientation=landscape",
    date: "2026-07-08",
    author: "编辑部",
    tags: ["粉丝见面会", "夏日之约", "东京巨蛋城", "应援"],
    viewCount: 22100,
  },
  {
    id: "a7",
    title: "佐佐木希最新代言：成为资生堂2026秋季彩妆系列亚洲区形象大使",
    slug: "shiseido-ambassador-2026",
    category: "最新动态",
    categorySlug: "news",
    excerpt: "国际美妆品牌资生堂正式宣布佐佐木希成为其2026秋季彩妆系列亚洲区形象大使，全新广告大片将于9月在全球同步上线。",
    content: `<p>国际知名美妆品牌资生堂（SHISEIDO）今日正式宣布，佐佐木希成为其2026秋季彩妆系列亚洲区形象大使。</p>
    <p>资生堂方面表示，佐佐木希身上兼具传统日本美学与现代女性自信的气质，与品牌"以美之力，点亮生活"的理念高度契合。此次合作将涵盖资生堂2026秋季全线彩妆产品，包括全新推出的"秋樱"系列唇膏和眼影盘。</p>
    <p>全新广告大片由国际知名摄影师Mario Sorrenti掌镜，在东京和纽约两地取景拍摄。广告中佐佐木希以极具东方韵味的妆容造型亮相，展现了资生堂秋季彩妆系列的丰富色彩和细腻质地。</p>
    <p>资生堂品牌总监表示："佐佐木希小姐是日本美的代表，我们非常荣幸能与她合作。相信她的魅力将为资生堂秋季彩妆系列带来全新的活力。"广告大片将于9月1日在全球同步上线。</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Elegant%20Japanese%20woman%20with%20flawless%20makeup%20in%20luxury%20beauty%20campaign%20shoot%2C%20cherry%20blossom%20pink%20lipstick%2C%20soft%20studio%20lighting%2C%20high-end%20cosmetics%20editorial%20photography%2C%20minimalist%20composition%2C%20warm%20neutral%20background&width=800&height=600&seq=article-a7-cover&orientation=landscape",
    date: "2026-06-25",
    author: "编辑部",
    tags: ["资生堂", "彩妆", "形象大使", "广告代言"],
    viewCount: 16780,
  },
  {
    id: "a8",
    title: "佐佐木希私服穿搭大公开：一周7天不重样的日系简约风",
    slug: "weekly-outfit-inspo-2026-summer",
    category: "时尚造型",
    categorySlug: "fashion",
    excerpt: "盘点佐佐木希最新一周私服穿搭，从休闲到正式场合，演绎日系简约高级风格，为你提供每日穿搭灵感。",
    content: `<p>作为日本最具时尚影响力的女艺人之一，佐佐木希的私服穿搭一直是粉丝们关注的焦点。我们整理了她在社交媒体和街拍中最新的7套日常穿搭，为你带来一周不重样的日系简约风灵感。</p>
    <p>周一的通勤造型选择了米色西装外套搭配白色阔腿裤，简约而不失职业感；周三的休闲日则是一件oversized针织衫搭配直筒牛仔裤，随性又温暖；周末的约会造型则是一条碎花连衣裙搭配米色针织开衫，温柔甜美。</p>
    <p>可以看出，佐佐木希的穿搭风格以"简约、舒适、高级"为关键词，善于运用基础款单品通过巧妙的搭配打造出不同的风格。她偏爱的品牌包括UNIQLO、GU、Mila Owen、Apuweiser-riche等日本本土品牌。</p>
    <p>时尚评论人山田表示："佐佐木希的穿搭之所以受欢迎，是因为她穿的不是遥不可及的奢侈品，而是普通女性也能轻松入手的单品，这种亲和力是她的魅力所在。"</p>`,
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20fashion%20model%20street%20style%20in%20beige%20blazer%20and%20white%20wide%20pants%20walking%20in%20Tokyo%20street%2C%20natural%20sunlight%2C%20minimalist%20Japanese%20fashion%2C%20candid%20street%20photography%2C%20warm%20urban%20background%2C%20effortless%20elegance&width=800&height=600&seq=article-a8-cover&orientation=landscape",
    date: "2026-06-18",
    author: "编辑部",
    tags: ["私服穿搭", "日系简约", "OOTD", "穿搭灵感"],
    viewCount: 25340,
  },
];

export const categories = [
  { name: "最新动态", slug: "news", icon: "ri-flashlight-line" },
  { name: "写真精选", slug: "photo", icon: "ri-camera-line" },
  { name: "影视作品", slug: "drama", icon: "ri-movie-line" },
  { name: "时尚造型", slug: "fashion", icon: "ri-shirt-line" },
  { name: "粉丝应援", slug: "fan", icon: "ri-heart-line" },
];